<!-- GeoBeacon vue -->
<template lang="pug">

div.geobeacon-wrapper(v-if="isMemoryBloc")
    div.param-ctn
        span.textinput-ctn.geobeacon-ctn
            input.value#GeoBeaconObjRef(type="text", v-model="memoryID", :disabled="false")
            div.clickableMask(v-on:click.stop="copyTextToClipboard(memoryID)") Copy Object Reference

span.textinput-ctn.geobeacon-ctn(v-else)
    input.value#GeoBeaconObjRef(type="text", v-model="memoryID", :disabled="true")
    div.clickableMask.clickableMask-mem(v-on:click.stop="copyTextToClipboard(memoryID)") Copy Object Reference

</template>

<script>
import { watch } from '@vue/composition-api';

export default {
    components: {
    },

    props:[ 'bloc' ],

    data() {
        return {
            isMemoryBloc: true,
        }
    },

    created: function() {
        // retrieve memory ID
        this.isMemoryBloc = this.bloc.value.type === 'memory';
        if (this.isMemoryBloc) this.memoryID = this.bloc.value._id;
        else if (this.bloc.value.fields) this.memoryID = this.bloc.value.fields.filter((f) => f.name === 'memoryId')[0].value;
    },

    computed: {
        memoryID: {
            get: function() {
                if (this.isMemoryBloc) return this.bloc.value._id;
                else if (this.bloc.value.fields) return this.bloc.value.fields.filter((f) => f.name === 'memoryId')[0].value;
                return 'not found';
            },
            set: function(value) {}
        }
    },

    methods: {
        copyTextToClipboard: function(text) {
            // fallback
            if (!navigator.clipboard) {
                const input = document.getElementById('GeoBeaconObjRef')
                input.select();
                document.execCommand('copy');
                input.blur();
            }
            else navigator.clipboard.writeText(text).then(
                () => console.log('Copying object reference to clipboard successfully'),
                (err) => console.error('Could not copy object reference:', err),
            );
        }
    }
}
</script>

<style lang="stylus">
.geobeacon-wrapper
    .param-ctn
        top: 0
        right: 0

.geobeacon-ctn
    input.value
        text-overflow: ellipsis
        opacity: 0.5

    .clickableMask
        height: auto
        width: calc(100% - 5px)
        line-height: 30px

    .clickableMask-mem
        width: calc(100% - 15px)
        text-overflow: ellipsis
        padding-left: 10px
        white-space: nowrap
        overflow: hidden
        line-height: 28px
        top: 6px
</style>
